// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3PZgg","dragIcon":"SortableItem_dragIcon__1vpGY","disabled":"SortableItem_disabled__yRYoG"};